import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware, { SagaMiddlewareOptions } from 'redux-saga'
import reduxLogger from 'redux-logger'
import { rootReducer } from './reducers'
import { rootSaga } from './sagas'
import * as Sentry from '@sentry/react'
import { logger } from './utils/logger'

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})

const configureStore = (initialState = {}) => {
  const sagaMiddlewareOptions: SagaMiddlewareOptions = {}

  const saga = createSagaMiddleware(sagaMiddlewareOptions)

  // redux-logger keeps full prev/next state snapshots referenced from the console, which
  // bloats memory on low-end phones (Android kills the page while the camera is open).
  const middlewares =
    process.env.NODE_ENV === 'production'
      ? [saga, logger.createReduxMiddleware()]
      : [saga, reduxLogger, logger.createReduxMiddleware()]

  const store = createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middlewares), sentryReduxEnhancer),
  )

  saga.run(rootSaga)

  return { ...store }
}

export const store = configureStore()
